import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-patient-ids-dialog',
    templateUrl: './patient-ids-dialog.component.html',
    styleUrls: ['./patient-ids-dialog.component.scss'],
    standalone: false
})
export class PatientIdsDialogComponent {
  patientIDs: Array<{ value: string; facility: string }>;
  patientName: string;

  constructor(
    public dialogRef: MatDialogRef<PatientIdsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      patientIDs: Array<{ value: string; facility: string }>;
      patientName: string;
    }
  ) {
    this.patientIDs = data.patientIDs;
    this.patientName = data.patientName;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  trackByPatientId(index: number, patientId: { value: string; facility: string }): string {
    return `${patientId.facility}-${patientId.value}`;
  }
}
